"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      display: 'flex',
      width: '100%'
    }),
    content: (0, _extends2.default)({}, theme.typography.h1)
  };
}, {
  name: 'SxComProductDetailName'
});

function ProductDetailName(_ref) {
  var actions = _ref.actions,
      pClasses = _ref.classes,
      className = _ref.className,
      Component = _ref.component,
      componentProps = _ref.componentProps,
      h1 = _ref.product.h1,
      renderToGridArea = _ref.renderToGridArea,
      variant = _ref.variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["actions", "classes", "className", "component", "componentProps", "product", "renderToGridArea", "variant"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    actions: actions,
    variant: variant,
    className: classes.content
  }, componentProps), h1));
}

process.env.NODE_ENV !== "production" ? ProductDetailName.propTypes = {
  actions: _propTypes.default.node,
  classes: _propTypes.default.shape({
    content: _propTypes.default.string,
    gridArea: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  component: _propTypes.default.elementType,
  componentProps: _propTypes.default.shape({}),
  product: _propTypes.default.shape({
    h1: _propTypes.default.string
  }).isRequired,
  renderToGridArea: _propTypes.default.string,
  variant: _propTypes.default.string
} : void 0;
ProductDetailName.defaultProps = {
  actions: null,
  classes: undefined,
  className: undefined,
  component: 'div',
  componentProps: undefined,
  renderToGridArea: 'name',
  variant: 'page'
};
var _default = ProductDetailName;
exports.default = _default;